export interface Environment {
  portalUsUrl: string;
  portalCaUrl: string;
  apiUsBaseUrl: string;
  apiCaBaseUrl: string;
  supportEmail: string;
}

export const environment: Environment = {
  portalUsUrl: 'https://portal.qa.us.lifespeak.com',
  portalCaUrl: 'https://portal.qa.ca.lifespeak.com',
  apiUsBaseUrl: 'https://portal-api2.qa.us.lifespeak.com',
  apiCaBaseUrl: 'https://portal-api2.qa.us.lifespeak.com',
  supportEmail: 'member.support@lifespeak.com'
};
